import React from "react";

const TrustLogos = () => {
  // Technology partner/trust logos
  const logos = [
    { name: "Microsoft", icon: "M" },
    { name: "Apple", icon: "" },
    { name: "Google", icon: "G" },
    { name: "Windows", icon: "⊞" },
    { name: "Android", icon: "🤖" },
    { name: "iOS", icon: "📱" },
  ];

  // Für die Endlos-Laufschrift wird die Liste verdoppelt
  const marqueeLogos = [...logos, ...logos];

  return (
    <section className="py-10 md:py-12 bg-muted/40 border-y border-border overflow-hidden">
      <div className="mx-auto max-w-7xl px-6">
        <p className="text-center text-sm font-bold text-muted-foreground tracking-[0.2em] uppercase mb-8">
          Wir unterstützen alle gängigen Systeme
        </p>
      </div>

      {/* Endlos laufende Logos */}
      <div className="relative">
        {/* Weiche Kanten links/rechts */}
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-muted/90 to-transparent z-10 pointer-events-none" aria-hidden="true" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-muted/90 to-transparent z-10 pointer-events-none" aria-hidden="true" />

        <div className="flex w-max animate-marquee motion-reduce:animate-none motion-reduce:flex-wrap motion-reduce:justify-center motion-reduce:w-full gap-14 md:gap-20 px-8">
          {marqueeLogos.map((logo, i) => (
            <div
              key={i}
              className="flex items-center gap-3 text-navy/40 hover:text-navy transition-colors shrink-0"
              aria-hidden={i >= logos.length}
            >
              <span className="text-2xl md:text-3xl">{logo.icon}</span>
              <span className="text-lg md:text-xl font-bold tracking-tight">{logo.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustLogos;
